import { render, staticRenderFns } from "./copy-declaration-element.vue?vue&type=template&id=92bec470"
import script from "./copy-declaration-element.vue?vue&type=script&lang=ts"
export * from "./copy-declaration-element.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports